import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React, {useCallback} from "react";
import Button from "../../atoms/button/button.component.js";
import SearchBar from "../../molecules/search-bar/search-bar.components.js";
import Chip from "../../atoms/chip/chip.component.js";
import UnitMergeFilter from "../../molecules/filters/unit-merge-filter/unit-merge-filter.component.js";
import {FlexContainer, PageActions} from "./merge-unti-filter-module.styles.js";
function MergeUnitFilterModule({
  accountList,
  drawerOpen,
  groupList,
  initialValues,
  innerRef,
  loading,
  open,
  portfolioList,
  propertyList,
  onClose,
  onCloseAutocomplete,
  onOpenAutocomplete,
  onRefetchField,
  onReset,
  onSubmit,
  onOpenDrawer,
  term,
  onSearch,
  onRemoveFilter,
  listFilters
}) {
  const {
    t,
    tt
  } = useTranslation();
  const renderFilter = useCallback(() => {
    const parsedFilters = Object.keys(listFilters).map((filterName, nameKey) => {
      const values = Object.values(listFilters).map((filter) => filter.map((f) => f.label).join(", "));
      return {
        [filterName]: values[nameKey]
      };
    });
    return parsedFilters.filter((value) => Object.values(value)[0] !== "").map((filter, index) => {
      const filterName = Object.keys(filter).join();
      const filterValue = Object.values(filter);
      const chipLabel = [tt(`user.filter.${filterName}`), filterValue].join(": ");
      return /* @__PURE__ */ React.createElement(Chip, {
        key: index,
        color: "primary",
        variant: "filled",
        label: chipLabel,
        onDelete: () => onRemoveFilter(filterName.toString())
      });
    });
  }, [listFilters, onRemoveFilter, tt]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(PageActions, null, /* @__PURE__ */ React.createElement(FlexContainer, {
    flexDirection: "column"
  }, /* @__PURE__ */ React.createElement(FlexContainer, {
    marginBottom: 1
  }, /* @__PURE__ */ React.createElement(Button, {
    translate: "actions.filter",
    onClick: onOpenDrawer,
    startIcon: "filter_list"
  }), /* @__PURE__ */ React.createElement(SearchBar, {
    width: "23rem",
    label: t("property.input.search", {
      type: "property"
    }),
    value: term,
    onSearch
  })), /* @__PURE__ */ React.createElement(FlexContainer, null, renderFilter()))), drawerOpen && /* @__PURE__ */ React.createElement(UnitMergeFilter, {
    accountList,
    drawerOpen,
    groupList,
    initialValues,
    innerRef,
    loading,
    open,
    portfolioList,
    propertyList,
    onClose,
    onCloseAutocomplete,
    onOpenAutocomplete,
    onRefetchField,
    onReset,
    onSubmit
  }));
}
export default /* @__PURE__ */ React.memo(MergeUnitFilterModule);
